import { plural } from '../common/text.js'

export async function pickDirectoryFiles({ showDirectoryPicker } = {}) {
  const picker = showDirectoryPicker ?? globalThis.showDirectoryPicker
  if (typeof picker !== 'function') return null
  let root
  try {
    root = await picker.call(globalThis, { mode: 'read' })
  } catch (error) {
    if (error?.name === 'AbortError') return []
    throw error
  }
  if (!root) return []

  const files = []
  async function walk(directory, prefix = '') {
    const entries = []
    const iterator = typeof directory.values === 'function' ? directory.values() : directory.entries()
    for await (const entry of iterator) entries.push(Array.isArray(entry) ? entry[1] : entry)
    entries.sort((a, b) => String(a.name).localeCompare(String(b.name), undefined, { numeric: true, sensitivity: 'base' }))
    for (const entry of entries) {
      const path = prefix ? `${prefix}/${entry.name}` : entry.name
      if (entry.kind === 'directory') await walk(entry, path)
      else if (entry.kind === 'file') {
        const file = await entry.getFile()
        const relativePath = root.name ? `${root.name}/${path}` : path
        try {
          Object.defineProperty(file, 'webkitRelativePath', { configurable: true, value: relativePath })
        } catch {}
        files.push(file)
      }
    }
  }
  await walk(root)
  return files
}

export const childFolders = (folders, folderId) => folders.filter(g => (g.parentId || null) === (folderId || null))

export function subtreeIds(folders, folderId) {
  const ids = new Set([folderId])
  for (let grew = true; grew; ) {
    grew = false
    for (const g of folders)
      if (g.parentId && ids.has(g.parentId) && !ids.has(g.id)) {
        ids.add(g.id)
        grew = true
      }
  }
  return ids
}

export function collapseFolderSelection(folders, folderIds) {
  const chosen = new Set(folderIds ?? [])
  const byId = new Map(folders.map(g => [g.id, g]))
  return [...chosen].filter(id => {
    const seen = new Set([id])
    for (let cur = byId.get(id)?.parentId; cur && !seen.has(cur); cur = byId.get(cur)?.parentId) {
      if (chosen.has(cur)) return false
      seen.add(cur)
    }
    return true
  })
}

export const selectableRows = ({ loaded, excludedView, shown, folders }) => (!loaded ? undefined : excludedView ? shown : [...shown, ...folders])

export const filesIn = (files, folderId) => files.filter(f => (f.folderId || null) === (folderId || null))

export function breadcrumb(folders, projectName, folderId) {
  const byId = new Map(folders.map(g => [g.id, g]))
  const parts = []
  for (let g = folderId ? byId.get(folderId) : null; g; g = g.parentId ? byId.get(g.parentId) : null) parts.unshift({ id: g.id, name: g.name })
  return [{ id: null, name: projectName }, ...parts]
}

export function folderMeta({ subfolderCount = 0, fileCount = 0, totalFileCount = 0 }) {
  const parts = []
  if (subfolderCount) parts.push(plural(subfolderCount, 'folder'))
  parts.push(`${plural(fileCount, 'file')} here`)
  if (subfolderCount) parts.push(`${totalFileCount} incl. subfolders`)
  return parts.join(' · ')
}
